import React, {FC, useCallback, useState, useEffect} from "react";
import { useTask } from '../stateManagement/context';
import {
    ComponentTypeID,
    IControlMeasure,
    IControlMeasureFailureMode,
    IControlType,
    IProjectFailureMode
} from "../types/types";

import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@material-ui/core";
import FailureModesControlMeasureSelect from "./failure_mode_control_measure";
import ControlTypeSelection from "./control_type";
import Comments from "./comments";
import {Delete, Edit} from "@material-ui/icons";
import DialogContentText from "@material-ui/core/DialogContentText";
import control_measuers from "./control_measuers";
import AddRiskAssessmentDialog from "./add_risk_assessment_dialog";
import AddControlMeasureDialog from "./add_ccontrol_measure_dialog";



interface IControlMeasureProps {
    control_measure: IControlMeasure
    failure_modes: IProjectFailureMode[]
    control_types: IControlType[]
    control_measure_failure_modes: IControlMeasureFailureMode[]
    updateFailureModeControlMeasures: (failureModeControlMeasures: IControlMeasureFailureMode) => void;
    updateControlMeasures: (controlMeasure: IControlMeasure) => void;
}



const ControlMeasure: FC<IControlMeasureProps> = ({control_measure,
                                                      control_types,
                                                      failure_modes,
                                                      control_measure_failure_modes,
                                                      updateFailureModeControlMeasures,
                                                      updateControlMeasures}) => {


    const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
    const [areYouSure, setAreYouSure] = useState<boolean>(false);
    const [write_access, setWriteAccess] = useState<boolean>(false);

    let tasks = useTask()

    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])

    const getControlMeasureFailureModes = (): IControlMeasureFailureMode=> {
        let cfm = control_measure_failure_modes.find( (c) => c.priority === 1)

        if (cfm) {
            return cfm
        }

        let r = {control_measure_id: 0,
            project_failure_mode_id: -1,
            priority: 1}
        return r
    }

    const getPrimaryFailureMode = (failureMode: IProjectFailureMode): string => {
        let cfm = control_measure_failure_modes.find((c) => c.project_failure_mode_id === failureMode.id)
        if (cfm) {
            return cfm.priority.toString()
        }
        return "0"
    }

    const getControlTypeID = (control_measure: IControlMeasure) =>
    { if (control_measure.control_type_id) {
        return control_measure.control_type_id.toString()
    }
        return ""
    }


    const handleEdit = () => {
        setOpenAddDialog(true)
    }

    const addDialogCallback = useCallback(() => {
        setOpenAddDialog(false)

    }, [setOpenAddDialog]);

    const handleAreaYouSure = () => {
        setAreYouSure(false)
    }


    const handleDelete = () => {

        let ra = {...control_measure}
        ra.is_active = false
        updateControlMeasures(ra)
        setAreYouSure(false)
    }

    const renderAreYouSure = () => {
        return(
            <Dialog open={areYouSure} onClose={handleAreaYouSure} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">Remove  {control_measure.description}</DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        <Typography>
                            Are you sure you want to remove failure mode <b>{control_measure.description}</b>
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleAreaYouSure} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleDelete} color="primary">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }

    return (
        <>{renderAreYouSure()}
            {openAddDialog && <AddControlMeasureDialog controlMeasure={control_measure}
                                                       updateControlMeasure={updateControlMeasures}
                                                       closeDialogCallback={addDialogCallback}/>}
       <TableRow>
           <TableCell style={{ position: "sticky", left: 0, zIndex: 2 , backgroundColor: "#FFFFFF" }}>{control_measure.description}</TableCell>
           <TableCell style={{ position: "sticky", left: "100px", zIndex: 2,backgroundColor: "#FFFFFF"  }}>{control_measure.comment}</TableCell>
           <TableCell style={{ position: "sticky", left: "200px", zIndex: 2 ,backgroundColor: "#FFFFFF" }}><ControlTypeSelection control_types={control_types}
                                            initial_selection_id={getControlTypeID(control_measure)}
                                            control_measure={control_measure}
                                            updateControlMeasure={updateControlMeasures}/></TableCell>
           {
               failure_modes.map( (fm) => {
                       return  (<TableCell style={{ backgroundColor: "#FFFFFF" }}><FailureModesControlMeasureSelect failure_mode={fm}
                                                                                      control_measure={control_measure}
                                                                                      updateControlMeasure={updateFailureModeControlMeasures}
                                                                                      control_measure_failure_mode={getControlMeasureFailureModes()}
                                                                                      initial_selection_id={getPrimaryFailureMode(fm)}/></TableCell>)
               })
           }

           <TableCell  style={{ zIndex: 1 }}>{control_measure.document?.name}</TableCell>
           <TableCell  style={{ zIndex: 1 }}>{control_measure.uuid && <Comments parent_uuid={control_measure.uuid} type_id={ComponentTypeID.ControlMeasure}/>}</TableCell>
           <TableCell  style={{ zIndex: 1 }}>

                {write_access && <>

               <IconButton color="primary" aria-label="upload picture" component="span" style={{
                   color:"rgb(239,88,43)",

               }} onClick={() => handleEdit()}>
                   <Edit />
               </IconButton>

               <IconButton color="primary" aria-label="upload picture" component="span"  style={{
                   color:"rgb(239,88,43)",

               }} onClick={() => setAreYouSure(true)} >
                   <Delete />
               </IconButton>
               </> }
           </TableCell>




       </TableRow>
        </>
    );
}

export default ControlMeasure;
